<template>
  <div>
    <v-btn color="purple" @click="backToTownships" text>
      <v-icon left> mdi-arrow-left-thin-circle-outline </v-icon>
      go Back
    </v-btn>
    <v-row justify="center">
      <v-col lg="8">
        <v-card class="card--shadow">
          <v-card-title>
            <v-spacer />
            <v-btn
              @click="viewPresumptiveReferral"
              class="mt-2 mr-1"
              outlined
              color="teal accent-4"
              dark
            >
              <v-icon left dark>mdi-format-list-bulleted</v-icon> Referred and
              Examined (Volunteer)
            </v-btn>
            <v-btn
              @click="viewPresumptiveList"
              class="mt-2 mr-1"
              outlined
              color="teal accent-4"
              dark
            >
              <v-icon left dark>mdi-format-list-bulleted</v-icon>Examined
              (Referred by Vol+FO+Self)
            </v-btn>
            <v-btn
              @click="viewSupportingTownshipPresumptiveList"
              class="mt-2 mr-1"
              outlined
              color="teal accent-4"
              dark
            >
              <v-icon left dark>mdi-format-list-bulleted</v-icon>Presumptive Township
            </v-btn>
            <v-btn
              @click="viewCreatePst"
              class="mt-2"
              outlined
              color="teal accent-4"
              dark
            >
              <v-icon left dark>mdi-plus-circle-outline</v-icon>new
            </v-btn>
          </v-card-title>
          <v-card-title> Contact Tracing </v-card-title>
          <v-card-text>
            <div class="d-flex justify-space-between">
              <div>
                <label>Index Case Code</label>
                <v-text-field
                  v-model.trim="indexCode"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </div>
              <div>
                <label>Index Case Year</label>
                <v-text-field
                  v-model.trim="indexYear"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </div>
              <div>
                <label>Mono-Poly</label>
                <v-select
                  v-model="monopoly"
                  :items="initialMonopoly"
                  dense
                  outlined
                ></v-select>
              </div>
              <!-- <div>
                <label>Initial</label>
                <v-select
                  v-model="initial"
                  :items="initialOpt"
                  dense
                  outlined
                ></v-select>
              </div> -->
              <div class="align-self-center">
                <v-btn
                  height="40"
                  color="purple accent-4"
                  @click.prevent="searchPspByIndexCode"
                  outlined
                  rounded
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>Search
                </v-btn>
              </div>
            </div>
            <v-row v-if="showList && !loading && indexCode && indexYear">
              <v-btn
                @click="addCloseContact"
                class="mt-2"
                outlined
                color="teal accent-4"
                dark
              >
                <v-icon left dark>mdi-plus-circle-outline</v-icon>Add
               Close Contact
              </v-btn>
              <v-btn
                @click="addOtherContact"
                class="mt-2"
                outlined
                color="teal accent-4"
                dark
              >
                <v-icon left dark>mdi-plus-circle-outline</v-icon>Add
               Other Contact
              </v-btn>
              <v-btn
                @click="addFamilyMember"
                class="mt-2"
                outlined
                color="teal accent-4"
                dark
              >
                <v-icon left dark>mdi-plus-circle-outline</v-icon>Add Family Member
              </v-btn>
            </v-row>
          </v-card-text>
          <v-card-title> Follow up </v-card-title>
          <v-card-text>
            <div class="d-flex justify-space-between">
              <div>
                <label> Code</label>
                <v-text-field
                  v-model.trim="followCode"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </div>
              <div>
                <label> Year</label>
                <v-text-field
                  v-model.trim="followYear"
                  type="text"
                  outlined
                  dense
                ></v-text-field>
              </div>
              <div>
                <label>Mono/Poly</label>
                <v-select
                  v-model="followmonopoly"
                  :items="initialMonopoly"
                  dense
                  outlined
                ></v-select>
              </div>
              <!-- <div>
                <label>Initial</label>
                <v-select
                  v-model="followInitial"
                  :items="initialOpt"
                  dense
                  outlined
                ></v-select>
              </div> -->
              <div class="align-self-center">
                <v-btn
                  height="40"
                  color="purple accent-4"
                  @click.prevent="searchPspByPreviousCode"
                  outlined
                  rounded
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>Search
                </v-btn>
              </div>
            </div>
            <v-row v-if="showList && !loading && followCode && followYear">
              <v-btn
                @click="addFollowUp"
                class="mt-2"
                outlined
                color="teal accent-4"
                dark
              >
                <v-icon left dark>mdi-plus-circle-outline</v-icon>Add Follow Up
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
        <div v-if="showList && !loading" class="mt-5">
          <section v-if="presumptiveData.length == 0 && patient">
           <v-card
             elevation="0"
             color="pink accent-1"
             class="pa-2 d-flex justify-center bg-pink"
           >
           <p class="noti-text white--text">
               <v-icon class="white--text mr-1"
                 >mdi-clipboard-alert-outline</v-icon
               >Sorry, patient exists but no family members!
             </p>
           </v-card>
         </section>

         <section v-if="!patient && presumptiveData.length == 0">
        
           <v-card
             elevation="0"
             color="pink accent-1"
             class="pa-2 d-flex justify-center bg-pink"
           >
           <p class="noti-text white--text">
               <v-icon class="white--text mr-1"
                 >mdi-clipboard-alert-outline</v-icon
               >Sorry, patient does not exist!
             </p>
           </v-card>
         </section>

          <!-- <section v-if="presumptiveData==null || presumptiveData.length == 0 ">
            <v-card
              elevation="0"
              color="pink accent-1"
              class="pa-2 d-flex justify-center bg-pink"
            >
              <p class="noti-text white--text">
                <v-icon class="white--text mr-1"
                  >mdi-clipboard-alert-outline</v-icon
                >Sorry, no match patients!
              </p>
            </v-card>
          </section> -->
          <div v-else>
           <search-list v-if="showList && !loading && presumptiveData.length>0 " :updatedPresumptiveData="updatedPresumptiveData" />
         </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { required } from "vuelidate/lib/validators";
import SearchList from "@/components/presumptive/SearchList.vue";
import { mapState } from "vuex";

export default {
  mixins: [ValidationMixin],
  components: {
    SearchList,
  },
  data: () => ({
    showList: false,
    initialMonopoly: ["No","Yes","SG"],
    initial: null,
    indexYear: null,
    indexCode: null,
    monopoly:null,
    followmonopoly:null,
    previousID: null,
  }),
  validations: {
    IndexYear: {
      required,
    },
    indexCode: {
      required,
    },
  },
  methods: {
    backToTownships() {
      this.$router.push({
        name: "pre-townships",
      });
    },
    searchPspByIndexCode() {
      if (this.indexYear && this.indexCode) {
        this.followCode = "";
        this.followYear = "";
        let data = {
          index_case_no: this.indexCode,
          index_case_year: this.indexYear,
          index_case_monopoly: this.monopoly === "Yes" ? 2 : (this.monopoly === "No" ? 1 : (this.monopoly === "SG" ? 3 : 1)),
          township_id: this.$route.params.township_id,
          // index_case_initial: this.initial ? this.initial : "",
          case_found_at: 3,
        };

        this.showList = false;
        this.$store.dispatch("Patient/getByIndexCode", data).then(() => {
          this.$store
            .dispatch("Presumptive/searchByIndexCode", data)
            .then(() => {
              this.showList = true;
            });
        });
      }
    },
    searchPspByPreviousCode() {
      if (this.followCode && this.followYear) {
        this.indexCode = "";
        this.indexYear = "";
        let data = {
          index_case_no: this.followCode,
          index_case_year: this.followYear,
          index_case_monopoly:this.followmonopoly=="Yes" ? 2 : 1,
          index_case_initial: "",
          // index_case_initial: this.followInitial ? this.followInitial : "",
          township_id: this.$route.params.township_id,
          case_found_at: 5,
        };
        this.showList = false;
         
        this.$store
            .dispatch("Presumptive/searchByIndexCode", data)
            .then(() => {
              this.showList = true;
            });
            
            // searchByPreviousCode
        //   this.$store.dispatch("Presumptive/storeCi", data).then(() => {
        //   this.showList = true;
        // });
      }
    },
    viewCreatePst() {
      this.$router.push({
        name: "create-presumptive",
        params: {
          township_id: this.$route.params.township_id,
          type: JSON.stringify({ type: "New" }),
        },
      });
    },
    viewPresumptiveList() {
      this.$router.push({
        name: "presumptive-list",
        params: { township_id: this.$route.params.township_id },
      });
    },
    viewSupportingTownshipPresumptiveList() {
      this.$router.push({
        name: "presumptive-list",
        query: {supportingTownship: true},
        params: { township_id: this.$route.params.township_id },
      });
    },
    viewPresumptiveReferral() {
      this.$router.push({
        name: "presumptive-referral",
        params: { township_id: this.$route.params.township_id },
      });
    },
    addCloseContact() {
      this.$router.push({
        name: "create-presumptive",
        params: {
          township_id: this.$route.params.township_id,
          type: JSON.stringify({
            type: "close-contact",
            index_case_no: this.indexCode,
            index_case_year: this.indexYear,
            index_case_monopoly: this.monopoly,
          }),
        },
      });
    },
    addOtherContact() {
      this.$router.push({
        name: "create-presumptive",
        params: {
          township_id: this.$route.params.township_id,
          type: JSON.stringify({
            type: "other-contact",
            index_case_no: this.indexCode,
            index_case_year: this.indexYear,
            index_case_monopoly: this.monopoly,
          }),
        },
      });
    },
    addFollowUp() {
      this.$router.push({
        name: "create-presumptive",
        params: {
          township_id: this.$route.params.township_id,
          type: JSON.stringify({
            type: "Follow-up",
            index_case_no: this.followCode,
            index_case_year: this.followYear,
          }),
        },
      });
    },
    addFamilyMember() {
     
      if (this.patient) {
        this.$router.push({
          name: "PatientFamily",
          params: {
            patient_id: this.patient.id,
          },
        });
      } else {
         this.$toast.error("Patient not found");
      //  alert("Patient not found");
      }
    },
  },

  computed: {
    ...mapState("Presumptive", ["presumptiveData"]),
    ...mapState("Patient", ["patient"]),
    ...mapState("Loading", ["loading"]),
  },
  created() {
    this.$store.dispatch("Presumptive/clearData");
  },
};
</script>

<style scoped>
.noti-text {
  color: #ffffff;
  font-size: 18px;
  margin-top: 10px;
  margin-right: 10px;
  letter-spacing: 1px;
}
</style>
